import { render, staticRenderFns } from "./vw-labor-time-guide-page.vue?vue&type=template&id=5e376133&scoped=true&"
import script from "./vw-labor-time-guide-page.vue?vue&type=script&lang=js&"
export * from "./vw-labor-time-guide-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e376133",
  null
  
)

export default component.exports